module.exports = __webpack_public_path__ + "static/media/favicon.fc7f1d2c.ico";